var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHumanoApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-humano-app"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-humano-app",
    clipPath: "url(#clip-Icon-humano-app)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1332",
    "data-name": "Rectangle 1332",
    width: 71,
    height: 71,
    rx: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(-76.551 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(111.37 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M62.765,48.9a9.1,9.1,0,0,1-18.014,0H39a14.929,14.929,0,0,0,29.734,0Z",
    transform: "translate(-39 -48.9)",
    fill: "#07b1e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M32.28,44.364H21.211V35.9H14.7V62.487h6.511V50.007H32.28V62.487h6.4V35.9h-6.4Z",
    transform: "translate(70.3 34.1)",
    fill: "#07b1e2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHumanoApp);
export default __webpack_public_path__ + "static/media/Icon-humano-app.efcd0a354808097597a4938aadc6f182.svg";
export { ForwardRef as ReactComponent };